import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-3">
      <div className="container">
        <p>&copy; 2023 Your Library. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
